import { useMemo } from 'react';

import { useDashboard } from '@/admin/dashboards/useDashboard';

import { aiTutorDashboardDefinition } from './definition';
import { mapAiTutorViewModel } from './mapAiTutorViewModel';

/**
 * Data layer for AI Tutor: fetches metrics and maps them to a plain view model.
 */
export function useAiTutorDashboard() {
  const dashboard = useDashboard(aiTutorDashboardDefinition);

  const gated = dashboard.filters?.gated ?? dashboard.appliedFilters.gated;

  const viewModel = useMemo(
    () => mapAiTutorViewModel(dashboard.metrics, gated),
    [dashboard.metrics, gated],
  );

  return { dashboard, viewModel };
}
